/**
 * Panel definitions for flex/dayAhead segment
 * Add your dayAhead-related panels here based on backend dataset configs
 */
import { applyCountryFilterToPanels } from './countryContext';

const basePanels = [
  // First row: 3 panels
  {
    id: 'day-ahead-prices-yesterday',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-prices',
    visualizationId: 'epex-day-ahead-prices-yesterday-chart',
    gridPos: { x: 0, y: 0, w: 8, h: 10 },
  },
  {
    id: 'day-ahead-prices-today',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-prices',
    visualizationId: 'epex-day-ahead-prices-today-chart',
    gridPos: { x: 8, y: 0, w: 8, h: 10 },
  },
  {
    id: 'day-ahead-prices-tomorrow',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-prices',
    visualizationId: 'epex-day-ahead-prices-tomorrow-chart',
    gridPos: { x: 16, y: 0, w: 8, h: 10 },
  },
  // Second row: 1 panel full width (24 cols)
  {
    id: 'day-ahead-prices-moving-average',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-prices',
    visualizationId: 'epex-day-ahead-prices-moving-average',
    gridPos: { x: 0, y: 10, w: 24, h: 12 },
  },
  // Third row: Price analysis charts - 3 panels for negative-price ISPs
  {
    id: 'negative-price-hours',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-quarter-hours',
    visualizationId: 'day-ahead-quarter-hours-negative-isp-chart',
    gridPos: { x: 0, y: 22, w: 8, h: 12 },
  },
  {
    id: 'negative-price-levels',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-quarter-hours',
    visualizationId: 'day-ahead-quarter-hours-negative-isp-levels-chart',
    gridPos: { x: 8, y: 22, w: 8, h: 12 },
  },
  {
    id: 'negative-price-value',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-quarter-hours',
    visualizationId: 'day-ahead-quarter-hours-negative-isp-value-chart',
    gridPos: { x: 16, y: 22, w: 8, h: 12 },
  },
  // Fourth row: 3 panels for positive-price ISPs
  {
    id: 'positive-price-hours',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-quarter-hours',
    visualizationId: 'day-ahead-quarter-hours-positive-isp-chart',
    gridPos: { x: 0, y: 34, w: 8, h: 12 },
  },
  {
    id: 'positive-price-levels',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-quarter-hours',
    visualizationId: 'day-ahead-quarter-hours-positive-isp-levels-chart',
    gridPos: { x: 8, y: 34, w: 8, h: 12 },
  },
  {
    id: 'positive-price-value',
    type: 'datasetChart',
    datasetId: 'epex-day-ahead-quarter-hours',
    visualizationId: 'day-ahead-quarter-hours-positive-isp-value-chart',
    gridPos: { x: 16, y: 34, w: 8, h: 12 },
  },
  // Fifth row: 1 panel full width
  {
    id: 'epex-intraday-vs-day-ahead',
    type: 'datasetChart',
    datasetId: 'epex-intraday-auctions',
    visualizationId: 'intraday-auctions-auctions-vs-day-ahead-chart',
    gridPos: { x: 0, y: 46, w: 24, h: 15 },
  },
];

export const flexDayAheadPanels = ({ country } = {}) =>
  applyCountryFilterToPanels(basePanels, country);

export const flexDayAheadSyncGroups = [
  {
    id: 'day-ahead-prices-row',
    global: false,
    ids: ['day-ahead-prices-yesterday', 'day-ahead-prices-today', 'day-ahead-prices-tomorrow'],
    syncAxes: { y: true },
  },
];
